// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Spinner__wrapper___2hsB2","text":"Spinner__text___3Xkn5","isLight":"Spinner__isLight____K5Vs","ldsRing":"Spinner__ldsRing___2TaoS","lds-ring":"Spinner__lds-ring___3debS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Spinner/Spinner.scss
// module id = 608
// module chunks = 0